import uniqid from "uniqid";

// only responsible for setting tabIndex hook
const Tab = ({
  texts,
  tabIndex,
  setTabIndex,
  gridCol = "grid-cols-[repeat(3,min-content)]",
}) => {
  return (
    <div className={`grid ${gridCol} gap-x-4 pt-8 pl-12  mr-8`}>
      {texts.map((text, index) => {
        return (
          <button
            onClick={() => setTabIndex(index)}
            key={uniqid()}
            className={`${index === tabIndex ? "" : "bg-custom-dark-gray"} whitespace-nowrap font-chinese text-custom-gray hover:bg-white text-md border-2 border-b-0 py-2 w-28  text-center`}
          >
            {text}
          </button>
        );
      })}
    </div>
  );
};

export default Tab;
